import i18n from "i18next";
import AsyncStoragePlugin from "i18next-react-native-async-storage";
import { initReactI18next } from "react-i18next";

import deCommon from "../locales/de/common.json";
import deEnums from "../locales/de/enum.json";
import deMenu from "../locales/de/menu.json";
import deValidation from "../locales/de/validation.json";
import enCommon from "../locales/en/common.json";
import enEnums from "../locales/en/enum.json";
import enMenu from "../locales/en/menu.json";
import enValidation from "../locales/en/validation.json";

i18n
	.use(initReactI18next)
	.use(AsyncStoragePlugin("de"))
	.init({
		fallbackLng: "en",
		ns: ["common", "validation", "enum", "menu"],
		defaultNS: "common",
		resources: {
			en: {
				common: enCommon,
				validation: enValidation,
				enum: enEnums,
				menu: enMenu,
			},
			de: {
				common: deCommon,
				validation: deValidation,
				enum: deEnums,
				menu: deMenu,
			},
		},
	});

export default i18n;
